module.exports = new __parcel__URL__("Fundraising Database Hover.6c691554.svg").toString();